import React from 'react';

export default class Smile extends React.PureComponent {
  render() {
    const radius = this.props.canvasSize / 2;
    return (
      <g fill="none">
        <circle className="fill-current" cx={radius} cy={radius} r={radius} />
        <path
          d="M27.977 26.225c.015-.239.023-.48.023-.725 0-4.142-2.239-7.5-5-7.5s-5 3.358-5 7.5c0 .245.008.486.023.725 1.142-1.2 2.946-1.975 4.977-1.975 2.03 0 3.835.775 4.977 1.975zM45.977 26.225c.015-.239.023-.48.023-.725 0-4.142-2.239-7.5-5-7.5s-5 3.358-5 7.5c0 .245.008.486.023.725 1.142-1.2 2.946-1.975 4.977-1.975 2.03 0 3.835.775 4.977 1.975z"
          style={{ fill: 'rgba(0,0,0,0.67)' }}
        />
        <path
          d="M48 41c-2.467 5.275-8.477 9-15.5 9S19.467 46.275 17 41c3.861 2.822 9.376 4.589 15.5 4.589 6.124 0 11.639-1.767 15.5-4.589z"
          style={{ fill: 'rgba(0,0,0,0.67)' }}
        />
      </g>
    );
  }
}
